module.exports = __webpack_public_path__ + "img/reward-bubble-5.70689c73.png";